import { Component, Input, ViewChild } from '@angular/core';

/**
 * Alert for service errors
 * Supports default error cases and custom error text.
 *
 * Default cases:
 * ```html
 * <mem-alert title="CONTRACTS.H1"></mem-alert>
 * ```
 *
 * Custom error text:
 * ```html
 * <mem-alert title="CONTRACTS.H1">
 *  Custom error message here!!
 * </mem-alert>
 * ```
 *
 * Note: title attribute can be ommitted for messages without titles.
 */

@Component({
  selector: 'mem-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})

// We could enhance it to support big/small icons
export class AlertComponent {
  @Input() title: string;

  // Global Error flag could be removed. I struggled with reasoning wether to add this or not
  // but i think the exception is the global errors and most of the time we will
  // use feature error and its nice to be able to just pass the header name
  // for the feature errors
  @Input() globalError: boolean;
  @Input() type = 'error'; // Need to check with Eric to see how many alert types are there.
  @ViewChild('content') content; // Needed this to prevent AOT error.
}



// WEBPACK FOOTER //
// ./src/app/shared/alert/alert.component.ts